export const POST_PURCHASE_EFFECTIVENESS = {
  NONE: "none",
  SOME: "some",
  SIGNIFICANT: "significant",
} as const;

export const POST_PURCHASE_FINAL_STEPS = {
  SHOW_RECOMMENDATIONS: "show_recommendations",
  SHOW_SUBSCRIPTION: "show_subscription",
} as const;

export const POST_PURCHASE_NEXT_STEPS_TYPES = {
  ALERT: "alert",
  ADVICE: "advice",
} as const;

export const SKUS = {
  GUIDED_RAPID_RELIEF: "EOC128",
} as const;

export const VARIANT_IDS = {
  GUIDED_RAPID_RELIEF: "51240146862382",
} as const;

export const SELLING_PLANS = {
  ONE_MONTH_SUB: "692003963182",
} as const;

export const SURVEY_ENTRY_SOURCES = {
  ORGANIC: "organic",
  NOTIFICATION: "notification",
  PROMO_CARD: "promo_card",
  REFILL_CARD: "refill_card",
} as const;

/** Where `GET /survey/check/completion` sends the patient once their check-in is processed. */
export const POST_SURVEY_DESTINATION = {
  CAREPLAN: "careplan",
  PROGRESS: "progress",
} as const;

/** The route each destination names. The wire value is never a path. */
export const POST_SURVEY_DESTINATION_ROUTE = {
  [POST_SURVEY_DESTINATION.CAREPLAN]: "/careplan",
  [POST_SURVEY_DESTINATION.PROGRESS]: "/progress",
} as const;
